const { SITE_NAME, BRAND_NAME } = process.env;
import pluralize from "pluralize";

export default (store) => {
	return [
		{
			"@context": "https://schema.org",
			"@type": "BreadcrumbList",
			"itemListElement": [
				{
					"@type": "ListItem",
					"position": 1,
					"item": {
						"@id": `https://${store.content.site}.com/`,
						"name": BRAND_NAME,
						"url": `https://${store.content.site}.com/`,
					},
				},
				{
					"@type": "ListItem",
					"position": 2,
					"item": {
						"@id": `https://${store.content.site}.com${store.content.folder}`,
						"name": `${pluralize(store.content.contentType.ucFirst())}`,
						"url": `https://${store.content.site}.com${store.content.folder}`,
					},
				},
				{
					"@type": "ListItem",
					"position": 3,
					"item": {
						"@id": `https://${store.content.site}.com${store.content.folder}${store.content.slug}`,
						"name": store.content.name,
						"url": `https://${store.content.site}.com${store.content.folder}${store.content.slug}`,
					},
				},
			],
		},
		{
			"@context": "https://schema.org",
			"@type": "Article",
			"mainEntityOfPage": {
				"@type": "WebPage",
				"@id": `https://${store.content.site}.com${store.content.folder}${store.content.slug}`,
			},
			"headline": store.content.title,
			"name": store.content.title,
			"url": `https://${store.content.site}.com${store.content.folder}${store.content.slug}`,
			"keywords": store.content.seoKeywords,
			"image": store.bodyAssets.map((asset) => asset.url),
			"thumbnailUrl": store.thumbnailUrl,
			"datePublished": store.firstPublishedAt.raw,
			"dateModified": store.publishedAt.raw,
			"author": store.authors.map((author) => ({
				"@type": "Person",
				"name": author.name,
				//"sameAs": "XXX",
			})),
			"editor": store.editors.map((editor) => ({
				"@type": "Person",
				"name": editor.name,
				//"sameAs": "XXX",
			})),
			"creator": store.authors.map((author) => ({
				"@type": "Person",
				"name": author.name,
				//"sameAs": "XXX",
			})),
			"publisher": {
				"@type": "Organization",
				"name": BRAND_NAME,
				"logo": {
					"@type": "ImageObject",
					"url": `https://static.${store.content.site}.com/assets/images/${store.content.site}_60.png`,
				},
			},
			"description": store.content.description,
			//"teaches": "only show if SITE_NAME === tutors --- Article.Name XXXX",
		},
		...store.reviewers.map((reviewer) => ({
			"@context": "https://schema.org",
			"@type": "WebPage",
			"name": store.content.title,
			"lastReviewed": store.publishedAt.raw,
			"reviewedBy": {
				"@type": "Person",
				"name": reviewer.name,
				"jobTitle": reviewer.role,
				"sameAs": `https://${store.content.site}.com/about`,
			},
		})),
		store.content.schema && {
			"currency": "USD",
			"maxValue": store.content.schema.monetaryAmountMaxValue,
			"minValue": store.content.schema.monetaryAmountMinValue,
			"value": "Number",
			"@context": "https://schema.org",
			"@type": "MonetaryAmount",
		},
	].filter(Boolean);
};
